import React from 'react';

function DateInput({label, id, name, required, get, set, readOnly, disabled}) {
    return (
        <div>
            <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900">
                {label} {required && <span className="text-red-500" aria-label="Required">*</span>}
            </label>
            <div className="mt-2">
                <input
                    id={id}
                    name={name}
                    type="date"
                    value={get}
                    disabled={disabled}
                    onChange={e => set(e.target.value)}
                    required={required || false}
                    readOnly={readOnly || false}
                    className="block disabled:opacity-60 disabled:bg-gray-200 w-full rounded-2xl border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 transition-all duration-200"
                />
            </div>
        </div>
    );
}

export default DateInput;